export default __webpack_public_path__ + "media/images/icons/check-simple-5a69f1ae0d382410453a42e892811216.svg";